import '../../startup/public-path';
import '../destination/styles/main.less';
import app from '../../startup/app';
import hydrateApp from '../../startup/hydrate-app';
import {Template} from '../../../shared/templates/adaptive-landing';

app(() => hydrateApp(Template));
